// extracted by mini-css-extract-plugin
export default {"loading":"animal-events_loading__Go04N"};